/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Form, InputNumber, Button, Select, Input } from "antd";
import {
  updateSubscription,
  getSubscription,
} from "../../features/subscription/subscriptionSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
import { useParams } from "react-router-dom";

const { Option } = Select;

const EditSubscription = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, updating, message, isUpdateSuccess, subscription } =
    useSelector((state) => state.subscription);
  const [form] = Form.useForm();
  const [period, setPeriod] = useState(null);

  const onFinish = (values) => {
    const data = { ...values };
    dispatch(updateSubscription({ id, data }));
  };

  const handleValuesChange = (changedValues) => {
    if (changedValues.period) {
      setPeriod(changedValues.period);
    }
  };

  useEffect(() => {
    loadSubscription();
  }, []);

  useEffect(() => {
    if (subscription) {
      form.setFieldsValue({
        name: subscription.name,
        currency: subscription.currency,
        amount: subscription.amount,
        period: subscription.period,
        hole_in_one_credits: subscription.hole_in_one_credits,
        hole_out_credits: subscription.hole_out_credits,
        status: subscription.status?.toString(),
        description: subscription.description,
      });
      setPeriod(subscription.period);
    }
  }, [subscription]);

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Subscription is updated successfully",
      });
      navigate("/admin/subscription");
    }
  }, [isError, message, isUpdateSuccess, messageApi, navigate]);

  const loadSubscription = () => {
    dispatch(getSubscription(id));
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Subscription & Bundle</h3>
      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Currency"
          name="currency"
          rules={[{ required: true, message: "Please select the currency!" }]}
        >
          <Select disabled={period !== "one-off"}>
            <Option value="aud">AUD</Option>
            <Option value="usd">USD</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Price"
          name="amount"
          rules={[{ required: true, message: "Please input the price!" }]}
        >
          <InputNumber
            min={0}
            style={{ width: "100%" }}
            disabled={period !== "one-off"}
          />
        </Form.Item>

        <Form.Item
          label="Period"
          name="period"
          rules={[{ required: true, message: "Please select the period!" }]}
        >
          <Select disabled={true}>
            <Option value="week">Weekly</Option>
            <Option value="month">Monthly</Option>
            <Option value="year">Yearly</Option>
            <Option value="one-off">One Off</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Hole In One Credits"
          name="hole_in_one_credits"
          rules={[
            { required: true, message: "Please input hole in one credits!" },
          ]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Hole Out Credits"
          name="hole_out_credits"
          rules={[
            { required: true, message: "Please input hole out credits!" },
          ]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
        
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please add a description!" }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={updating}>
            {updating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditSubscription;
